export const en = {
    additions: 'Extensions: {additionsList}',
    'banner-has-template': 'uses a template',
    id: 'No. {id}',
    info: '{bannerId} — {bannerHasTemplate}'
};
